/* eslint-disable prefer-template */
/* eslint-disable react/jsx-curly-newline */
/* eslint-disable no-return-assign */
import { useTranslation } from 'react-i18next';
import { Link, useLocation } from 'react-router-dom';
import { useState, useRef, useEffect, useContext } from 'react';
import { AbilityContext } from 'components/Can';

function AppTopbarMenu() {
  const { t } = useTranslation();
  const ability = useContext(AbilityContext);
  const location = useLocation();
  const [openDropdown, setOpenDropdown] = useState(null);
  const dropdownRefs = useRef({});

  useEffect(() => {
    function handleClickOutside(event) {
      const isClickInsideAny = Object.values(dropdownRefs.current).some(
        (ref) => ref && ref.contains(event.target)
      );
      if (!isClickInsideAny) {
        setOpenDropdown(null);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  function isActive(path) {
    return location.pathname === path || location.pathname.startsWith(path + '/');
  }

  function isSectionActive(section) {
    if (!section.items) return false;
    return section.items.some((item) => isActive(item.to));
  }

  const model = [
    {
      label: t('menu.dashboard.label'),
      items: [{ label: t('menu.dashboard.items.dashboard'), icon: 'pi pi-fw pi-home', to: '/' }],
    },
    {
      label: t('menu.proposal.label'),
      items: [
        {
          label: t('menu.proposal.items.proposal'),
          icon: 'pi pi-fw pi-list',
          to: '/proposals',
        },
      ],
    },
    {
      label: t('menu.projectProposal.label'),
      icon: 'pi pi-fw pi-file-check',
      items: [
        {
          label: t('menu.projectProposal.items.reviseProjectList'),
          icon: 'pi pi-fw pi-list',
          to: '/projects-revise',
        },
        {
          label: t('menu.projectProposal.items.submitProjectList'),
          icon: 'pi pi-fw pi-list',
          to: '/projects-submit',
        },
        {
          label: t('menu.projectProposal.items.completedProjectList'),
          icon: 'pi pi-fw pi-list',
          to: '/projects-completed',
        },
        {
          label: t('menu.pubProjectProposal.label'),
          icon: 'pi pi-fw pi-list',
          to: '/pub-projects-revise',
        },
      ],
    },
    {
      label: t('menu.projectProposal.items.councilProjectList'),
      items: [
        {
          label: t('menu.projectProposal.items.councilProjectList'),
          icon: 'pi pi-fw pi-list',
          to: '/councils',
        },
      ],
    },
    {
      label: t('menu.administration.label'),
      icon: 'pi pi-fw pi-cog',
      items: [
        {
          label: t('menu.administration.items.employee'),
          icon: 'pi pi-fw pi-users',
          to: '/employee',
        },
        {
          label: t('menu.administration.items.organization'),
          icon: 'pi pi-fw pi-building',
          to: '/organization',
        },
        {
          label: t('menu.administration.items.KpiGroup'),
          icon: 'pi pi-fw pi-tags',
          to: '/research-kpi-group',
        },
        {
          label: t('menu.administration.items.researchField'),
          icon: 'pi pi-fw pi-sitemap',
          to: '/research-field',
        },
        {
          label: t('menu.administration.items.bonusExpenditure'),
          icon: 'pi pi-fw pi-dollar',
          to: '/bonus-expenditure',
        },
        {
          label: t('menu.administration.items.program'),
          icon: 'pi pi-fw pi-server',
          to: '/program',
        },
        {
          label: t('menu.administration.items.programProposal'),
          icon: 'pi pi-fw pi-server',
          to: '/program-proposal',
        },
        {
          label: t('menu.administration.items.statistics'),
          icon: 'pi pi-fw pi-chart-bar',
          to: '/statistics',
        },
        {
          label: t('menu.administration.items.forms'),
          icon: 'pi pi-fw pi-file',
          to: '/forms',
        },
      ],
    },
  ];

  if (
    ability.cannot('read', 'employee') &&
    ability.cannot('read', 'organization') &&
    ability.cannot('read', 'research_kpi_group') &&
    ability.cannot('read', 'research_kpi') &&
    ability.cannot('read', 'research_field') &&
    ability.cannot('read', 'program') &&
    ability.cannot('read', 'statistic_detail') &&
    ability.cannot('read', 'bonus_expenditure') &&
    ability.cannot('read', 'proposal_program')
  ) {
    delete model[4];
  } else {
    if (ability.cannot('read', 'statistic_detail')) {
      delete model[4].items[7];
    }
    if (ability.cannot('read', 'proposal_program')) {
      delete model[4].items[6];
    }
    if (ability.cannot('read', 'program')) {
      delete model[4].items[5];
    }
    if (ability.cannot('read', 'bonus_expenditure')) {
      delete model[4].items[4];
    }
    if (ability.cannot('read', 'research_field')) {
      delete model[4].items[3];
    }
    if (ability.cannot('read', 'research_kpi') || ability.cannot('read', 'research_kpi_group')) {
      delete model[4].items[2];
    }
    if (ability.cannot('read', 'organization')) {
      delete model[4].items[1];
    }
    if (ability.cannot('read', 'employee')) {
      delete model[4].items[0];
    }
  }

  if (ability.cannot('read', 'pub_project_proposal')) {
    delete model[3];
  }

  if (ability.cannot('read', 'project_proposal')) {
    delete model[2];
  }

  if (ability.cannot('read', 'proposal')) {
    delete model[1];
  }

  if (ability.cannot('read', 'statistic')) {
    delete model[0];
  }

  const filteredModel = model.filter(Boolean);

  return (
    <nav className="layout-topbar-horizontal-menu">
      {filteredModel.map((section) => {
        if (section.items && section.items.length === 1) {
          const item = section.items[0];
          return (
            <Link
              key={item.to}
              to={item.to}
              className={`topbar-menu-link${isActive(item.to) ? ' active' : ''}`}
            >
              <i className={item.icon} />
              <span>{item.label}</span>
            </Link>
          );
        }

        if (section.items && section.items.length > 1) {
          const sectionIsActive = isSectionActive(section);
          return (
            <div
              key={section.label}
              className={`topbar-menu-link dropdown${sectionIsActive ? ' active' : ''}`}
              ref={(el) => (dropdownRefs.current[section.label] = el)}
            >
              <button
                type="button"
                tabIndex={0}
                className="dropdown-toggle-btn"
                onClick={() =>
                  setOpenDropdown(openDropdown === section.label ? null : section.label)
                }
                style={{
                  background: 'none',
                  border: 'none',
                  padding: 0,
                  display: 'flex',
                  alignItems: 'center',
                  cursor: 'pointer',
                }}
              >
                <i className={section.icon} style={{ marginRight: 7 }} />
                <span>{section.label}</span>
                <i className="pi pi-angle-down" style={{ marginLeft: 4 }} />
              </button>
              {openDropdown === section.label && (
                <div className={`dropdown-menu ${sectionIsActive ? 'dropdown-parent-menu' : ''}`}>
                  {section.items.map((item) => (
                    <Link
                      key={item.to}
                      to={item.to}
                      className={`dropdown-item${isActive(item.to) ? ' active' : ''}`}
                      onClick={() => setOpenDropdown(null)}
                    >
                      {item.icon && <i className={item.icon} style={{ marginRight: 8 }} />}
                      {item.label}
                    </Link>
                  ))}
                </div>
              )}
            </div>
          );
        }

        return null;
      })}
    </nav>
  );
}

export default AppTopbarMenu;
